export const NM_MOBILE_APP_HEIGHT_VAR = '--nm-mobile-app-height'
export const NM_MOBILE_KEYBOARD_INSET_VAR = '--nm-mobile-keyboard-inset'
export const KEYBOARD_OPEN_CLASS = 'nutrimatic-mobile-keyboard-open'

const KEYBOARD_OPEN_THRESHOLD_PX = 48

let resetScheduled = false

export function resetDocumentScrollIfNeeded() {
  if (window.scrollY === 0 && window.scrollX === 0) {
    if (
      document.documentElement.scrollTop === 0 &&
      document.documentElement.scrollLeft === 0 &&
      document.body.scrollTop === 0 &&
      document.body.scrollLeft === 0
    ) {
      return
    }
  }

  window.scrollTo(0, 0)
  document.documentElement.scrollLeft = 0
  document.documentElement.scrollTop = 0
  document.body.scrollLeft = 0
  document.body.scrollTop = 0
}

export function scheduleDocumentScrollReset() {
  if (resetScheduled || typeof window === 'undefined') return

  resetScheduled = true
  window.requestAnimationFrame(() => {
    resetScheduled = false
    resetDocumentScrollIfNeeded()
  })
}

/** Re-sincroniza métricas y scroll documental tras cambios de viewport (estándar Visual Viewport API). */
export function stabilizeMobileViewportLayout(root: HTMLElement = document.documentElement) {
  scheduleDocumentScrollReset()
  syncMobileViewportMetrics(root)
}

function isTextEntryFocused() {
  const active = document.activeElement
  if (!(active instanceof HTMLElement)) return false
  if (active instanceof HTMLInputElement || active instanceof HTMLTextAreaElement) return true
  return active.isContentEditable
}

export function syncMobileViewportMetrics(root: HTMLElement) {
  const layoutHeight = window.innerHeight
  root.style.setProperty(NM_MOBILE_APP_HEIGHT_VAR, `${layoutHeight}px`)

  const viewport = window.visualViewport
  let inset = 0

  if (viewport && isTextEntryFocused()) {
    inset = Math.max(0, Math.round(layoutHeight - viewport.height - viewport.offsetTop))
  }

  root.style.setProperty(NM_MOBILE_KEYBOARD_INSET_VAR, `${inset}px`)

  if (inset >= KEYBOARD_OPEN_THRESHOLD_PX) {
    root.classList.add(KEYBOARD_OPEN_CLASS)
  } else {
    root.classList.remove(KEYBOARD_OPEN_CLASS)
  }
}

export function clearMobileViewportMetrics(root: HTMLElement) {
  root.style.removeProperty(NM_MOBILE_APP_HEIGHT_VAR)
  root.style.removeProperty(NM_MOBILE_KEYBOARD_INSET_VAR)
  root.classList.remove(KEYBOARD_OPEN_CLASS)
}
